export default __webpack_public_path__ + "static/media/alexanderdrawing_thumb.eeb6f15c.jpg";